/* eslint-disable max-len */
export default {
  cooperate: {
    title: '公式認定パートナー',
    ifs: {
      logo: 'ifs-logo.png',
      name: '大中華圏正規総代理',
      tags: ['ERP', 'EAM', 'FSM', 'AI'],
    },
    deep_robot: {
      logo: 'deep-robot-logo.png',
      name: '雲深処科技中国地区A級代理',
      tags: ['四足歩行ロボット', 'ロボット関節'],
    },
  },
  title_pc: 'デザインとテクノロジーで、企業の\nデジタル化とスマート化を支援します',
  title_sp: 'デザインとテクノロジーで、\n企業のデジタル化とスマート\n化を支援します',
  description1_pc: '飛狼は中国を拠点とし、世界規模で活動する\nプロフェッショナル・チームです，エクスペリエンスデザイン、\nソフトウェア開発、およびシステムインテグレーションサービスを提供。',
  description1_sp: '飛狼は中国を拠点とし、世界規模で活動するプロフェッショナル・チームです，エクスペリエンスデザイン、ソフトウェア開発、およびシステムインテグレーションサービスを提供。',
  description2_pc: 'IFSの大中華圏における正規総代理および雲深処科技の代理として、\n当社はエンタープライズ・ソフトウェアとロボット・アプリケーションを実際の業務現場に導入し、\n企業の管理効率向上とインテリジェントなアプリケーションの活用拡大を支援します。',
  description2_sp: 'IFSの大中華圏における正規総代理および雲深処科技の代理として、当社はエンタープライズ・ソフトウェアとロボット・アプリケーションを実際の業務現場に導入し、企業の管理効率向上とインテリジェントなアプリケーションの活用拡大を支援します。',
};
